import Table from '@mui/material/Table';

export { Table };
